import { useState } from 'react';
import { PhoneIcon, XMarkIcon } from '@heroicons/react/24/outline';
import AircallCallButton from './AircallCallButton';

// Modal para realizar llamadas
function CallModal({ expedientId, debtorId, buttonClassName }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        className={`w-full px-4 py-2 bg-white border border-slate-200 rounded-lg hover:bg-slate-100 text-sm font-medium transition-colors flex items-center justify-center gap-2 ${buttonClassName}`}
        onClick={() => setIsOpen(true)}
      >
        <PhoneIcon className='w-4 h-4' />
        Llamar
      </button>
      {isOpen && (
        <div className='fixed z-50 inset-0 overflow-y-auto'>
          <div className='flex items-center justify-center min-h-screen px-4'>
            <div
              className='fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity'
              onClick={() => setIsOpen(false)}
            ></div>
            <div className='bg-white rounded-lg shadow-xl transform transition-all sm:max-w-2xl sm:w-full relative z-20'>
              <div className='p-6'>
                <div className='flex items-center justify-between mb-4'>
                  <h3 className='text-lg font-semibold text-gray-800'>Realizar Llamada</h3>
                  <button type='button' onClick={() => setIsOpen(false)} className='text-gray-400 hover:text-gray-600'>
                    <XMarkIcon className='w-5 h-5' />
                  </button>
                </div>
                <div className='mt-6'>
                  <AircallCallButton
                    expedientId={expedientId}
                    debtorId={debtorId}
                    onCallSuccess={() => setIsOpen(false)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default CallModal;
